import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LibraryProvider } from './context/LibraryContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Search from './pages/Search';
import Browse from './pages/Browse';
import BookDetail from './pages/BookDetail';
import Library from './pages/Library';

function App() {
  return (
    <LibraryProvider>
      <Router>
        <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#0f0f1a' }}>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<Search />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/book/:id" element={<BookDetail />} />
              <Route path="/library" element={<Library />} />
            </Routes>
          </main>
          <footer className="border-t border-border py-8 mt-16">
            <div className="page-container text-center">
              <p className="text-gray-500 text-sm">
                &copy; {new Date().getFullYear()} LibreBooks &mdash; Powered by{' '}
                <a href="https://gutenberg.org" target="_blank" rel="noopener noreferrer"
                  className="text-accent hover:underline">Project Gutenberg</a>
                {' '}&amp;{' '}
                <a href="https://openlibrary.org" target="_blank" rel="noopener noreferrer"
                  className="text-accent hover:underline">Open Library</a>
              </p>
              <p className="text-gray-600 text-xs mt-2">
                All books are in the public domain and free to read, download, and share.
              </p>
            </div>
          </footer>
        </div>
      </Router>
    </LibraryProvider>
  );
}

export default App;
